<header class="shadow">
  <nav class="navbar navbar-expand-lg navbar-light bg-white">
    <div class="container-xl">
        <a class="navbar-brand navbar-logo" routerLink="/"><img alt="LaboCorp | Payer" class="branding" src="assets/public/images/logo-payer-color.png"></a>
    </div>
  </nav>
</header>
